import { getInvoicePaymentTotal } from '@/modules/Invoice/services'
import { formatCurrency } from '@/utils/function'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { Typogaphy } from 'vnetwork-ui'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface InvoicePaymentAmountProps {
    invoiceID: number
}

const InvoicePaymentAmount = ({ invoiceID }: InvoicePaymentAmountProps) => {
    const { data, renderState } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.INVOICES_PAYMENT, invoiceID],
        queryFn: () => getInvoicePaymentTotal({ invoiceID }),
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <Typogaphy>{formatCurrency(data?.result?.invoice_paid || 0)}</Typogaphy>
    )
}

export default InvoicePaymentAmount
